import { render, staticRenderFns } from "./RoomExtendMenu.vue?vue&type=template&id=a15e69f4&scoped=true&"
import script from "./RoomExtendMenu.vue?vue&type=script&lang=js&"
export * from "./RoomExtendMenu.vue?vue&type=script&lang=js&"
import style0 from "./RoomExtendMenu.vue?vue&type=style&index=0&id=a15e69f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15e69f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a15e69f4')) {
      api.createRecord('a15e69f4', component.options)
    } else {
      api.reload('a15e69f4', component.options)
    }
    module.hot.accept("./RoomExtendMenu.vue?vue&type=template&id=a15e69f4&scoped=true&", function () {
      api.rerender('a15e69f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/ExtendMenu/RoomExtendMenu.vue"
export default component.exports